var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"body-wrap"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{staticClass:"view-page"},[_c('left'),_c('wrapper',[_c('router-view')],1)],1)])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }